// @flow

export const isMobile = () => {
  return (
    typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

export const pageWithoutHeader = ['/pronos'];
